export const data = [{
	"id": 0,
	"rank":1,
	"city": "London",
	"country": "United Kingdom",
	"number": 1327,
	"pinColor": "#FF5A62",
	"coords": [51.5285582, -0.2416796]
},{
	"id": 1,
	"rank": 2,
	"city": "Tokyo",
	"country": "Japan",
	"number": 955,
	"pinColor": "#FF5C63",
	"coords": [35.6732619, 139.5703053]
}, {
	"id": 2,
	"rank": 3,
	"city": "New York",
	"country": "United States ",
	"number": 875,
	"pinColor": "#FE5E63",
	"coords": [40.6974034, -74.1197632]
}, {
	"id": 3,
	"rank": 4,
	"city": "Madrid",
	"country": "Spain",
	"number": 865,
	"pinColor": "#FE6064",
	"coords": [40.4378698, -3.8196188]
}, {
	"id": 4,
	"rank": 5,
	"city": "Barcelona",
	"country": "Spain",
	"number": 733,
	"pinColor": "#FE6264",
	"coords": [41.3947688, 2.0787284]
}, {
	"id": 5,
	"rank": 6,
	"city": "Prague",
	"country": "Czech Republic",
	"number": 601,
	"pinColor": "#FD6565",
	"coords": [50.0595854, 14.3255428]
}, {
	"id": 6,
	"rank": 7,
	"city": "Berlin",
	"country": "Germany",
	"number": 596,
	"pinColor": "#FD6765",
	"coords": [52.5067614, 13.284651]
}, {
	"id": 7,
	"rank": 8,
	"city": "Rome",
	"country": "Italy",
	"number": 523,
	"pinColor": "#FD6966",
	"coords": [41.909986, 12.3959159]
}, {
	"id": 8,
	"rank": 9,
	"city": "Chicago",
	"country": "United States",
	"number": 517,
	"pinColor": "#FD6B66",
	"coords": [41.8336479, -87.872046]
}, {
	"id": 9,
	"rank": 10,
	"city": "Istanbul",
	"country": "Turkey",
	"number": 421,
	"pinColor": "#FC6D67",
	"coords": [41.0052367, 28.8720973]
}, {
	"id": 10,
	"rank": 11,
	"city": "Paris",
	"country": "France",
	"number": 368,
	"pinColor": "#FC6F68",
	"coords": [48.8588377, 2.2770207]
}, {
	"id": 11,
	"rank": 12,
	"city": "Milan",
	"country": "Italy",
	"number": 344,
	"pinColor": "#FC7168",
	"coords": [45.4627124,9.1076929]
}, {
	"id": 12,
	"rank": 13,
	"city": "Los Angeles",
	"country": "United States",
	"number": 291,
	"pinColor": "#FB7369",
	"coords": [34.0201613, -118.6919124]
}, {
	"id": 13,
	"rank": 14,
	"city": "Las Vegas",
	"country": "United States",
	"number": 290,
	"pinColor": "#FB7569",
	"coords": [36.1249185, -115.3150826]
}, {
	"id": 14,
	"rank": 15,
	"city": "Moscow",
	"country": "Russia",
	"number": 284,
	"pinColor": "#FB776A",
	"coords": [55.5807482, 36.8251524]
}, {
	"id": 15,
	"rank": 16,
	"city": "San Francisco",
	"country": "United States ",
	"number": 275,
	"pinColor": "#FA7A6A",
	"coords": [37.7576948, -122.4726193]
}, {
	"id": 16,
	"rank": 17,
	"city": "Dublin",
	"country": "Ireland",
	"number": 264,
	"pinColor": "#FA7C6B",
	"coords": [53.3242381, -6.3857848]
}, {
	"id": 17,
	"rank": 18,
	"city": "Houston",
	"country": "United States",
	"number": 261,
	"pinColor": "#FA7E6B",
	"coords": [29.8168824, -95.6814729]
}, {
	"id": 18,
	"rank": 19,
	"city": "Hamburg",
	"country": "Germany",
	"number": 244,
	"pinColor": "#F9806C",
	"coords": [53.5584902, 9.7877408]
}, {
	"id": 19,
	"rank": 20,
	"city": "Amsterdam",
	"country": "Netherlands",
	"number": 243,
	"pinColor": "#F9826C",
	"coords": [52.3546274, 4.8285839]
}, {
	"id": 20,
	"rank": 21,
	"city": "Philadelphia",
	"country": "United States",
	"number": 236,
	"pinColor": "#F9846D",
	"coords": [40.0024137, -75.2581152]
}, {
	"id": 21,
	"rank": 22,
	"city": "Toronto",
	"country": "Canada",
	"number": 231,
	"pinColor": "#F9866E",
	"coords": [43.6567919, -79.4609318]
}, {
	"id": 22,
	"rank": 23,
	"city": "Sydney",
	"country": "Australia",
	"number": 222,
	"pinColor": "#F8886E",
	"coords": [-33.8479271, 150.6517948]
}, {
	"id": 23,
	"rank": 24,
	"city": "Munich",
	"country": "Germany",
	"number": 206,
	"pinColor": "#F88A6F",
	"coords": [48.1548895, 11.4717965]
}, {
	"id": 24,
	"rank": 25,
	"city": "Seattle",
	"country": "United States",
	"number": 204,
	"pinColor": "#F88C6F",
	"coords": [47.6129432, -122.4821459]
}, {
	"id": 25,
	"rank": 26,
	"city": "Glasgow",
	"country": "United Kingdom",
	"number": 200,
	"pinColor": "#F78F70",
	"coords": [55.8554403, -4.3024976]
}, {
	"id": 26,
	"rank": 27,
	"city": "Portland",
	"country": "United States",
	"number": 199,
	"pinColor": "#F79170",
	"coords": [45.5426867, -122.724426]
}, {
	"id": 27,
	"rank": 28,
	"city": "Manchester",
	"country": "United Kingdom",
	"number": 199,
	"pinColor": "#F79371",
	"coords": [53.472225, -2.293502]
}, {
	"id": 28,
	"rank": 29,
	"city": "New Orleans",
	"country": "United States",
	"number": 198,
	"pinColor": "#F69571",
	"coords": [30.0329222, -90.0226466]
}, {
	"id": 29,
	"rank": 30,
	"city": "Budapest",
	"country": "Hungary",
	"number": 195,
	"pinColor": "#F69772",
	"coords": [47.4811282, 18.9902216]
}, {
	"id": 30,
	"rank": 31,
	"city": "Austin",
	"country": "United States",
	"number": 192,
	"pinColor": "#F69973",
	"coords": [30.3076863, -97.8934845]
}, {
	"id": 31,
	"rank": 32,
	"city": "Montreal",
	"country": "Canada",
	"number": 183,
	"pinColor": "#f69b73",
	"coords": [45.5579564, -73.8703841]
}, {
	"id": 32,
	"rank": 33,
	"city": "San Diego",
	"country": "United States",
	"number": 181,
	"pinColor": "#f59d74",
	"coords": [32.8242404, -117.3891588]
}, {
	"id": 33,
	"rank": 34,
	"city": "Lisbon",
	"country": "Portugal",
	"number": 180,
	"pinColor": "#f59f74",
	"coords": [38.7436214, -9.1952226]
}, {
	"id": 34,
	"rank": 35,
	"city": "Melbourne",
	"country": "Australia",
	"number": 171,
	"pinColor": "#f5a175",
	"coords": [-37.9722342, 144.772957]
}, {
	"id": 35,
	"rank": 36,
	"city": "Washington",
	"country": "United States",
	"number": 170,
	"pinColor": "#f4a475",
	"coords": [38.8935755, -77.0846155]
}, {
	"id": 36,
	"rank": 37,
	"city": "Sao Paulo",
	"country": "Brazil",
	"number": 169,
	"pinColor": "#f4a676",
	"coords": [-23.6821604, -46.8754826]
}, {
	"id": 37,
	"rank": 38,
	"city": "St Petersburg",
	"country": "Russia",
	"number": 159,
	"pinColor": "#f4a876",
	"coords": [59.9399006, 29.8105225]
}, {
	"id": 38,
	"rank": 39,
	"city": "Denver",
	"country": "United States",
	"number": 158,
	"pinColor": "#f3aa77",
	"coords": [39.7642548, -104.9951937]
}, {
	"id": 39,
	"rank": 40,
	"city": "Dallas",
	"country": "United States",
	"number": 154,
	"pinColor": "#f3ac77",
	"coords": [32.8205865, -96.8716254]
}, {
	"id": 40,
	"rank": 41,
	"city": "Singapore",
	"country": "Singapore",
	"number": 151,
	"pinColor": "#f3ae78",
	"coords": [1.3139961, 103.7041656]
}, {
	"id": 41,
	"rank": 42,
	"city": "Copenhagen",
	"country": "Denmark",
	"number": 140,
	"pinColor": "#f2b079",
	"coords": [55.6712474, 12.5237849]
}, {
	"id": 42,
	"rank": 43,
	"city": "Bristol",
	"country": "United Kingdom",
	"number": 139,
	"pinColor": "#f2b279",
	"coords": [51.4684681,-2.6607486]
}, {
	"id": 43,
	"rank": 44,
	"city": "St Louis",
	"country": "United States",
	"number": 139,
	"pinColor": "#f2b47a",
	"coords": [38.6530796,-90.3135015]
}, {
	"id": 44,
	"rank": 45,
	"city": "Bangkok",
	"country": "Thailand",
	"number": 137,
	"pinColor": "#f2b67a",
	"coords": [13.7245601, 100.4930267]
}, {
	"id": 45,
	"rank": 46,
	"city": "Baltimore",
	"country": "United States",
	"number": 134,
	"pinColor": "#f1b97b",
	"coords": [39.2846854, -76.6905255]
}, {
	"id": 46,
	"rank": 47,
	"city": "Vienna",
	"country": "Austria",
	"number": 132,
	"pinColor": "#f1bb7b",
	"coords": [48.2206636, 16.3100207]
}, {
	"id": 47,
	"rank": 48,
	"city": "Boston",
	"country": "United States",
	"number": 131,
	"pinColor": "#f1bd7c",
	"coords": [42.3143286, -71.0403234]
}, {
	"id": 48,
	"rank": 49,
	"city": "Birmingham",
	"country": "United Kingdom",
	"number": 131,
	"pinColor": "#f0bf7c",
	"coords": [52.4774169, -1.9336706]
}, {
	"id": 49,
	"rank": 50,
	"city": "Frankfurt",
	"country": "Germany",
	"number": 130,
	"pinColor": "#f0c17d",
	"coords": [50.1211277, 8.4964827]
}];






// WEBPACK FOOTER //
// ./src/data.js